const $productsForm = $("#products-form");
const $productsResponse = $("#products-response");
const $projectsFilters = $productsForm.find("select, input");
const $filterButton = $(".submit-mobile-filters-button");

function filterProjects() {
  $productsResponse.addClass("loading");

  setTimeout(function () {
    $.ajax({
      url: "/wp-admin/admin-ajax.php",
      data: $productsForm.serialize() + "&action=products_filter",
      type: "GET",
      beforeSend: function (xhr) {},
      success: function (data) {
        $productsResponse.html(data);
      },
      complete: function (data) {
        $productsResponse.removeClass("loading");
      },
    });
  }, 300);
}

function handleFilterChange() {
  var currentFilter = $(this);

  $projectsFilters.off("change", handleFilterChange);

  $projectsFilters.not(currentFilter).each(function () {
    $(this).val(null).trigger("change.select2");
  });

  $projectsFilters.on("change", handleFilterChange);

  filterProjects();
}

$projectsFilters.on("change", handleFilterChange);
